<template>
  <div class="exp-resource container">
    <el-card>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/personal/course'}">我的资源</el-breadcrumb-item>
        <el-breadcrumb-item>实验项目</el-breadcrumb-item>
      </el-breadcrumb>
      <h1 class="resoure-title">{{courseTitle}}</h1>
        <el-select v-model="expType" placeholder="按实验类型查看" size="small" @change="handleTypeChange">
            <el-option v-for="type in types" :key="type.id" :label="type.label" :value="type.id"></el-option>
        </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-select v-model="valueTag" placeholder="按实验标签查看" size="small" @change="handChange">
            <el-option v-for="tag in tags" :key="tag.uid" :label="tag.tagName" :value="tag.uid"></el-option>
        </el-select>
        <el-button class="add-btn" type="primary" icon="el-icon-plus" size="small" @click="beforeAdd">创建实验项目</el-button>
    <el-table :data="expData" style="width: 100%"  :cell-style="cellStyle" :header-cell-style="rowClass">
      <el-table-column
        prop="expName"
        label="实验名称"
      ></el-table-column>
      <!-- <el-table-column label="课程" width="180">
        <template slot-scope="{ row }">
          <el-tag type="success">{{ row.courseName }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="标签" width="150">
        <template slot-scope="{ row }">
          <el-tag
            type="success"
            v-for="item in row.expTagNames"
            :key="item.id"
            >{{ item }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="类型" width="150">
        <template slot-scope="{ row }">
          <el-tag type="success">{{(types.filter(type => type.id === row.type))[0].label}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="labExpNum" label="课堂实验数" width="150">
        <template slot-scope="{ row }">
            <el-link type="primary" @click="$router.push(`/course/${$route.params.id}/${row.uid}/lesson_exps`)">{{row.labExpNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="324">
        <template slot-scope="{ row }">
          <el-button size="mini" @click="handView(row)">预览</el-button>
          <!-- <el-button size="mini" v-if="row.createUser == userInfo.id" @click="$router.push(`/course/${$route.params.id}/${row.uid}/lesson_exps`)">查看课堂实验</el-button> -->
          <el-button size="mini" v-if="row.createUser == userInfo.id" :disabled="row.expContentType === 1" @click="handleEdit(row)">编辑</el-button>
          <el-button size="mini" v-if="row.createUser == userInfo.id" :disabled="row.createUser !== userInfo.id || row.labExpNum > 0" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="createTime" label="创建时间"> </el-table-column> -->
      <!-- <el-table-column prop="status" label="状态"> </el-table-column> -->
    </el-table>
    <el-pagination
      background
      prev-text="上一页"
      next-text="下一页"
      layout="total, prev, pager, next, jumper"
      :total="page.total"
      :current-page="page.page"
      :page-size="page.limit"
      :pager-count="page.pagerCount"
      @current-change="handlePageChange"
      style="margin-top:15px"
      hide-on-single-page
    ></el-pagination>
    </el-card>
    <expResourceDialog ref="expResourceDialog" :dataForm="dataForm" @itemChange="getList"/>
  </div>
</template>
<script>
import { selectTagList } from '@/api/exp/exptag'
import  expResourceDialog  from './components/exp-resource-dialog'
import { getEntity as courseGetEntity} from "@/api/exp/course";


import {
  getExpList,
  remove,
  duplicateCheck,
  getEntity
} from '@/api/exp/experiment'
import { mapGetters } from 'vuex'

export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入实验名称'))
      } else {
        //远程验证实验名称是否存在
        duplicateCheck({ id: this.dataForm.id, expName: value }).then(res => {
          if (res) {
            callback(new Error('实验名称已存在，请重新输入'))
          }
          callback()
        })
      }
    }
    return {
      courseTitle:'',
      activeName: 'person',
      data: [],
      courses: [],
      tags: [],
      types: [
        { id: 1, label: '创造型' },
        { id: 2, label: '设计型' },
        { id: 3, label: '验证型' },
        { id: 4, label: '故障型' }
      ],
      dataForm: {},
      fileList: [],
      rules: {
        expName: [{ validator: validateName, trigger: 'blur' }],
        expTags: [
          { required: true, message: '请选择实验标签', trigger: 'blur' }
        ],
        courseId: [
          { required: true, message: '请选择所属课程', trigger: 'blur' }
        ]
      },
      valueTag:'',  //筛选标签用
      expType: '',
      expTypes: [
        { id: 1, label: '富文本' },
        { id: 2, label: '文档' }
      ],
      pubilcStatus: [
        { id: 0, label: '不公开' },
        { id: 1, label: '公开' }
      ],
      newArr: [], //创建一个空数组用来保存添加的软件信息
      expData: [],
      page: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  components: {
    expResourceDialog
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.init()
  },
  methods: {
    handlePageChange(page) {  //分页
      this.$set(this.page, 'page', page)
      this.getList()
    },
    handleTypeChange () {
      this.$set(this.page, 'page', 1)
      this.getList()
    },
    handChange(){ // 当便签页筛选发生变化时
      this.$set(this.page, 'page', 1)
      this.getList()
    },
    init() {
      this.selectTagList() // 获取实验标签列表
      this.getList() // 获取个人创建的实验项目列表
      this.courseGetEntity()
    },
    handleEdit(row) {
      // 编辑操作
      getEntity(row.id)
          .then((res = {
            softs: null
          }) => {
            const softs = res.softs || JSON.stringify([])
            this.dataForm = {
              softs: [],
              ...res,
            }
            try {
              this.dataForm.softs = JSON.parse(softs)
            } catch (e) {
              // do something
            }
            this.$refs['expResourceDialog'].changeVisible(true)
          })
    },
    handleDelete(row) {
      //删除操作
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove([row.id])
        })
        .then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    getList() {
      // 获取个人创建的实验项目列表
      const { valueTag, expType } = this
      const { page, limit } = this.page
      const { id } = this.$route.params
      let params = {
        courseId: id
      }
      if (valueTag)
        params.findInSetExpTags = valueTag
      if (expType)
        params.type = expType
      getExpList(page, limit, params).then(res => {
        const { totalCount, list } = res
        this.expData = list
        this.$set(this.page, 'total', totalCount)
      })
    },
    courseGetEntity(){
        const { id } = this.$route.params
        courseGetEntity(id).then(res=>{
            this.courseTitle = res.courseName
        })
    },
    selectTagList() {
      // 获取标签列表
      selectTagList().then(res => {
        // 过滤标签列表，只看自己创建的标签
        this.tags = res.filter(tag => tag.createUser === this.userInfo.id)
      })
    },
    beforeAdd() {
      const { id } = this.$route.params
      // 打开实验项目编辑对话框
      this.$refs['expResourceDialog'].changeVisible(true)
      // this.fileList = []
      this.dataForm = {
        courseId: Number(id)
      }
    },
    handView(row){  //预览界面
        const { id } = this.$route.params
        this.$router.push(`/exp/view/${id}/${row.id}`)
    },
    cellStyle(){
        return "text-align:center"
    },
    rowClass(){
        return "text-align:center"
    }
  }
}
</script>
<style lang="less">
.exp-resource {
  .add-btn {
    float: right;
  }
  .resoure-title{
      text-align: center;
      margin: 24px 0;
  }
}
</style>
